import { Injectable } from '@angular/core';
import { OrdersService } from './orders.service';
import { NavigationService } from './navigation.service';
import { DeviceSessionService } from './device-session.service';
import * as proto from 'src/proto/compiled-protos';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessageHandlerService {

  constructor(
      private navigationService: NavigationService,
      private deviceSessionService: DeviceSessionService,
      private ordersService: OrdersService){
  }

  // We don't call FirebaseService.getFirebaseMessagingToken() to avoid a circular dependency.
  public onIsFirebaseMessagingEnabled() {
    this.ordersService.onIsFirebaseMessagingEnabled();
  }

  // We don't call FirebaseService.getFirebaseMessagingToken() to avoid a circular dependency.
  public onIsFirebaseMessagingDisabled() {
    this.ordersService.onIsFirebaseMessagingDisabled();
  }

  public handleMessage(message: proto.waiternow.common.ClientNotificationProto) {
    if (message.newOrder) {
      this.ordersService.fetchPendingOrders();
    } else if (message.orderStatusUpdated) {
      const order = message.orderStatusUpdated.order;
      if (order && order.status) {
        // This case is for orders that are marked as paid. They are not new orders.
        if (!order.status.acked) {
          this.ordersService.fetchPendingOrders();
        }
        else if (order.status.acked) {
          this.ordersService.orderAcked(order);
        } else if (order.status.completed) {
          this.ordersService.orderCompleted(order);
        }
      }
    }
    // TODO: if Firebase notifications are not supported or allowed, we need a way
    // to pull whether we need to terminate the session of the business web.
    else if (message.terminateDeviceSessionRequest) {
    this.deviceSessionService.endSessionAndLogout();
      this.navigationService.goToSignInPage();
    }
  }
}
